import { render, staticRenderFns } from "./ColorsFlavors.vue?vue&type=template&id=946662ce&scoped=true&"
import script from "./ColorsFlavors.vue?vue&type=script&lang=js&"
export * from "./ColorsFlavors.vue?vue&type=script&lang=js&"
import style0 from "./ColorsFlavors.vue?vue&type=style&index=0&id=946662ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946662ce",
  null
  
)

export default component.exports